import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Button from '@material-ui/core/Button';
import ReadCookie from '../functions/readcookies';
import { Grid, Popup, Input } from 'semantic-ui-react';
import Resetpassword from './login/resetpassword'
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import Loading from './loadings';
import $ from "jquery";
import Server from '../functions/server';
import Version from '../functions/version';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Drawer from './drawer/drawer';
import DomainName from '../functions/domainName';

const styles = theme => ({
  root: { flexGrow: 1 },
  grow: { flexGrow: 1 },
  menuButton: { marginLeft: -12, marginRight: 20 },
});

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class Title extends React.Component {

state = {
  branchs: [],
  changeBranchDialog: false
}

componentDidMount() {
  this.executive();
  this.displayBranch();
}

executive() {
  let cook = (ReadCookie("vaigai"));
  let name = cook.name;
  this.setState({ executiveName: name })
}

displayBranch() {
  let data = (ReadCookie("branch"));
  let branchName;
  try {
    for (var i = 0; i < data.length; i++) {
      branchName = data[i].name;
    }
  } catch (e) {
  }
  this.setState({ branch: branchName })
}

logout() {
  document.cookie.split(";").forEach(function(c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
  window.location.assign(DomainName());
}

resetpassword() { this.setState({ resetpwd: true }) }

textBoxHandle = (type) => event => {
  this.setState({ [type]: event.target.value })
}

submit() {
  let context = this;
  let password = this.state.password;
  let conformpassword = this.state.conformPassword;
  let cook = (ReadCookie("vaigai"));
  let id = cook.id;
  if (password != conformpassword) {
    alert('Password and Conform Password are Mis-Matched!!!!');
    return;
  }
  context.setState({ loading: true, message: 'Updating Password!!!' });
  $.ajax({
    url: Server()+'/login/resetpwd.php',
    method: 'POST',
    data: { 'password': password, 'id': id },
    success: (data) => {
      context.setState({ loading: false });
      if (data == 1) {
        alert("Password Reseted Successfully!!!")
        context.setState({ resetpwd: false, password: '', conformPassword: '' })
      }
    },
    error: (e) => {
      context.setState({ loading: false, error: 'Try again!!!' });
    }
  });
}

changeBranch() {
  let context = this;
  let cook = (ReadCookie("vaigai"));
  let id = cook.id;
  context.setState({ loading: false, message: 'Getting Branch Details!!!' });
  $.ajax({
    url: Server()+'executivebranch/getbranch.php',
    method: 'POST',
    data: { 'userId': id },
    success: (data) => {
      try {
        data = JSON.parse(data);
        context.setState({ branchs: data, changeBranchDialog: true })
      } catch (e) {
      }
      context.setState({ loading: false });
    },
    error: (e) => {
      context.setState({ loading: false, error: 'Try again!!!' });
    }
  });
}

selectedBranch(id) {
  let items = [];
  let data = this.state.branchs;
  data.map((z) =>{
    if (z.id == id) {
      items.push(z);
    }
  });
  items = JSON.stringify(items);
  items = JSON.stringify(items);
  this.setCookie(items);
}

setCookie(data) {
  this.createCookie('branch', data, 7);
}

createCookie(name,value,days) {
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + value + expires + ";path=/";
  this.setState({ changeBranchDialog: false })
  localStorage.setItem("customerDualScreenorderList", "[]");
  window.location.reload();
}

render() {
  const { classes } = this.props;
  return (
    <div className={classes.root}>
      <Loading load={this.state.load} message={this.state.message} />

      <AppBar position="static">
        <Toolbar>
          <IconButton className={classes.menuButton} onClick={this.props.openDrawer} color="inherit" aria-label="Menu">
            <Drawer />
          </IconButton>
          <Typography variant="h6" color="inherit" className={classes.grow}>
            {this.props.title}
          </Typography>
          <b style={{marginRight: '6%', cursor: 'pointer'}} onClick={this.changeBranch.bind(this)}>
            {this.state.branch}
          </b>
          <div style={{marginTop: '2%'}}>
            <Popup wide trigger={<Button variant="outlined">{'Hi..'+this.state.executiveName}</Button>} on='click'>
                <Button onClick={this.resetpassword.bind(this)}>Reset Password</Button><br/>
                <Button onClick={this.logout.bind(this)}>Logout</Button>
            </Popup><br/>
            <div style={{fontSize: '12px', textAlign: 'right'}}>{Version()}</div>
          </div>
          
        </Toolbar>
      </AppBar>

      <Dialog open={this.state.changeBranchDialog} TransitionComponent={Transition}
        keepMounted onClose={ () => { this.setState({ changeBranchDialog: false }) }} aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description">
        <DialogTitle id="alert-dialog-slide-title" style={{width: 250}}>
          {"Select Branch"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <List>
              { this.state.branchs.map((c) => {
                  return (
                    <ListItem button onClick={this.selectedBranch.bind(this, c.id)}>
                      <ListItemText primary={c.name} />
                    </ListItem>
                  )
                })
              }
            </List>
          </DialogContentText>
        </DialogContent>
      </Dialog>

      <Dialog open={this.state.resetpwd} TransitionComponent={Transition}
        keepMounted onClose={ () => { this.setState({ resetpwd: false }) }} aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description">
        <DialogTitle id="alert-dialog-slide-title" style={{width: 500}}>
          {"Reset Password"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <Grid>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                Password<br/>
                <Input type='password' fluid value={this.state.password} onChange={this.textBoxHandle('password')} />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                Re-type Password<br/>
                <Input type='password' fluid value={this.state.conformPassword} onChange={this.textBoxHandle('conformPassword')} />
              </Grid.Column>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.submit.bind(this)} color="primary">
            Okey
          </Button>
          <Button onClick={ () => { this.setState({ resetpwd: false }) }} color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
}

Title.propTypes = {
classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Title);
